module.exports = __webpack_public_path__ + "static/media/Rectangle 69.09f7bd57.png";